import {
  FETCH_SUPERVISOR_EVENTS_REQUEST,
  FETCH_SUPERVISOR_EVENTS_SUCCESS,
  FETCH_SUPERVISOR_EVENTS_FAILURE,

  FETCH_SUPERVISOR_EVENT_STUDENTS_REQUEST,
  FETCH_SUPERVISOR_EVENT_STUDENTS_SUCCESS,
  FETCH_SUPERVISOR_EVENT_STUDENTS_FAILURE,

  FETCH_SUPERVISOR_EVENT_HOSTS_REQUEST,
  FETCH_SUPERVISOR_EVENT_HOSTS_SUCCESS,
  FETCH_SUPERVISOR_EVENT_HOSTS_FAILURE,

  FETCH_SUPERVISOR_EVENT_SCHOOLS_REQUEST,
  FETCH_SUPERVISOR_EVENT_SCHOOLS_SUCCESS,
  FETCH_SUPERVISOR_EVENT_SCHOOLS_FAILURE,

  FETCH_SUPERVISOR_SCHOOL_EVENT_STUDENTS_REQUEST,
  FETCH_SUPERVISOR_SCHOOL_EVENT_STUDENTS_SUCCESS,
  FETCH_SUPERVISOR_SCHOOL_EVENT_STUDENTS_FAILURE,

  FETCH_SUPERVISOR_HOST_REQUEST,
  FETCH_SUPERVISOR_HOST_SUCCESS,
  FETCH_SUPERVISOR_HOST_FAILURE,
  EDIT_SUPERVISOR_HOST_SUCCESS,

  SUPERVISOR_FETCH_PROMO_CODES_REQUEST,
  SUPERVISOR_FETCH_PROMO_CODES_SUCCESS,
  SUPERVISOR_FETCH_PROMO_CODES_FAILURE,

  FETCH_SINGLE_PROMO_CODE_REQUEST,
  FETCH_SINGLE_PROMO_CODE_SUCCESS,
  FETCH_SINGLE_PROMO_CODE_FAILURE,

  SUPERVISOR_FETCH_EVENT_DOCUMENTS_REQUEST,
  SUPERVISOR_FETCH_EVENT_DOCUMENTS_SUCCESS,
  SUPERVISOR_FETCH_EVENT_DOCUMENTS_FAILURE,
} from '../actions/actions'

export const events = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SUPERVISOR_EVENTS_REQUEST:
      return { ...state, isLoading: true }

    case FETCH_SUPERVISOR_EVENTS_SUCCESS:
      return { ...state, data: action.data, isLoading: false }

    case FETCH_SUPERVISOR_EVENTS_FAILURE:
      return { ...state, errors: action.error, isLoading: false }

    default:
      return state
  }
}

export const students = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SUPERVISOR_EVENT_STUDENTS_REQUEST:
      return { ...state, isLoading: true }

    case FETCH_SUPERVISOR_EVENT_STUDENTS_SUCCESS:
      return { ...state, data: action.data, isLoading: false }

    case FETCH_SUPERVISOR_EVENT_STUDENTS_FAILURE:
      return { ...state, errors: action.error, isLoading: false }

    default:
      return state
  }
}

export const hosts = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SUPERVISOR_EVENT_HOSTS_REQUEST:
      return { ...state, isLoading: true }

    case FETCH_SUPERVISOR_EVENT_HOSTS_SUCCESS:
      return { ...state, data: action.data, isLoading: false }

    case FETCH_SUPERVISOR_EVENT_HOSTS_FAILURE:
      return { ...state, errors: action.error, isLoading: false }

    default:
      return state
  }
}

export const schools = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SUPERVISOR_EVENT_SCHOOLS_REQUEST:
      return { ...state, isLoading: true }

    case FETCH_SUPERVISOR_EVENT_SCHOOLS_SUCCESS:
      return { ...state, data: action.data, isLoading: false }

    case FETCH_SUPERVISOR_EVENT_SCHOOLS_FAILURE:
      return { ...state, errors: action.error, isLoading: false }

    default:
      return state
  }
}

export const schoolStudents = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SUPERVISOR_SCHOOL_EVENT_STUDENTS_REQUEST:
      return { ...state, isLoading: true }

    case FETCH_SUPERVISOR_SCHOOL_EVENT_STUDENTS_SUCCESS:
      return { ...state, data: action.data, isLoading: false }

    case FETCH_SUPERVISOR_SCHOOL_EVENT_STUDENTS_FAILURE:
      return { ...state, errors: action.error, isLoading: false }

    default:
      return state
  }
}

export const host = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SUPERVISOR_HOST_REQUEST:
      return { ...state, isLoading: true }

    case FETCH_SUPERVISOR_HOST_SUCCESS:
      return { ...state, data: action.data, isLoading: false }

    case FETCH_SUPERVISOR_HOST_FAILURE:
      return { ...state, errors: action.error, isLoading: false }

    default:
      return state
  }
}

export const promoCodes = (state = {}, action) => {
  switch (action.type) {
    case SUPERVISOR_FETCH_PROMO_CODES_REQUEST:
      return { ...state, isLoading: true }

    case SUPERVISOR_FETCH_PROMO_CODES_SUCCESS:
      return { ...state, data: action.data, isLoading: false }

    case SUPERVISOR_FETCH_PROMO_CODES_FAILURE:
      return { ...state, errors: action.error, isLoading: false }

    default:
      return state
  }
}

export const promoCode = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SINGLE_PROMO_CODE_REQUEST:
      return { ...state, isLoading: true }

    case FETCH_SINGLE_PROMO_CODE_SUCCESS:
      return { ...state, data: action.promo_code, isLoading: false }

    case FETCH_SINGLE_PROMO_CODE_FAILURE:
      return { ...state, errors: action.error, isLoading: false }

    default:
      return state
  }
}

export const eventSupportTicket = (state = {}, action) => {
  switch (action.type) {
    case SUPERVISOR_FETCH_EVENT_DOCUMENTS_REQUEST:
      return { ...state, isLoading: true }

    case SUPERVISOR_FETCH_EVENT_DOCUMENTS_SUCCESS:
      return { ...state, ticket: action.ticket, isLoading: false }

    case SUPERVISOR_FETCH_EVENT_DOCUMENTS_FAILURE:
      return { ...state, errors: action.error, isLoading: false }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/supervisorReducers.js